const App = {
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.ScrollTo();
    App.SetBackground();
  },
};

function InitSlider() {
  var heroBanner = new Swiper(".hero-banner .swiper-container", {
    speed: 1500,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".hero-banner .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
  });
  var boardMembersSlide = new Swiper(".board-members .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 15,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".board-members .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
  });

  $(".brands-slider").slick({
    rows: 3,
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });
  var certificateSlider = new Swiper(".certificate .swiper-container", {
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: -15,
    loopedSlides: 6,
    slideToClickedSlide: true,
    observer: true,
    observeParents: true,
    grabCursor: true,
    loop: true,
    autoplay: {
      delay: 4500,
    },
    speed: 500,
    preventInteractionOnTransition: true,
    navigation: {
      prevEl: ".certificate .swiper-prev",
      nextEl: ".certificate .swiper-next",
    },
    on: {
      slideChange: function () {
        var activeIndex = this.activeIndex;
        var realIndex = this.slides
          .eq(activeIndex)
          .attr("data-swiper-slide-index");
        $(".swiper-slide").removeClass(
          "swiper-slide-nth-prev-2 swiper-slide-nth-next-2"
        );
        $('.swiper-slide[data-swiper-slide-index="' + realIndex + '"]')
          .prev()
          .prev()
          .addClass("swiper-slide-nth-prev-2");
        $('.swiper-slide[data-swiper-slide-index="' + realIndex + '"]')
          .next()
          .next()
          .addClass("swiper-slide-nth-next-2");
      },
    },
    breakpoints: {
      992: {
        slidesPerView: 2.5,
      },
      576: {
        slidesPerView: 2,
      },
    },
  });
}

function Headers() {
  $(document).on("click", ".toggle-btn", function () {
    $("body").toggleClass("overflow-hidden");
    $(".header").toggleClass("change-color");
    $(this).toggleClass("active");
    $(".mobile-nav-inner").toggleClass("active");
  });
  $(document).on(
    "click",
    ".mobile-nav-inner li.has-dropdown > .icon-dropdown",
    function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parents(".has-dropdown").removeClass("active");
        $(this).next().slideUp();
      } else {
        $(".header .nav-sub").slideUp();
        $(".icon-dropdown").removeClass("active");
        $(".has-dropdown").removeClass("active");
        $(this).toggleClass("active").next().slideDown();
        $(this).parents(".has-dropdown").toggleClass("active");
      }
    }
  );
  $(window).on("resize", function () {
    $(".header").removeClass("change-color");
    $("header .mobile-nav-inner").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".toggle-btn").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });
  $(".header").on("click", ".close", function () {
    $(".header").removeClass("change-color");
    $("header .mobile-nav-inner").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".toggle-btn").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });
  $("header .mobile-nav-inner").on("click", ".menu__link", function () {
    $(this).toggleClass("active");
    $("header .mobile-nav-inner").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".toggle-btn").removeClass("active");
  });
}
//mapping
function mappings() {
  var moveSearch = new MappingListener({
    selector: ".header .searchbox",
    mobileWrapper: ".mobile-nav-inner",
    mobileMethod: "appendTo",
    desktopWrapper: ".header .social",
    desktopMethod: "insertBefore",
    breakpoint: 1200,
  }).watch();
  var moveNav = new MappingListener({
    selector: "header .menu",
    mobileWrapper: ".mobile-nav-inner",
    mobileMethod: "appendTo",
    desktopWrapper: "header .logo",
    desktopMethod: "insertAfter",
    breakpoint: 1200,
  }).watch();
  var moveinfo = new MappingListener({
    selector: ".hero-banner .have-questions",
    mobileWrapper: ".mobile-nav-inner",
    mobileMethod: "appendTo",
    desktopWrapper: ".hero-banner .slide-content .content",
    desktopMethod: "insertBefore",
    breakpoint: 768,
  }).watch();
}
function fixedNav() {
  var nav = $(".header");
  if (nav.length) {
    $(window).on("load scroll", function () {
      if ($(window).scrollTop() > 180) {
        nav.addClass("fixed");
      } else {
        nav.removeClass("fixed");
      }
    });
  }
}
function accordion() {
  if ($(".accordions").length) {
    $(".accordion-item.active").find(".accordion-content").show();
    $(".accordion-heading").on("click", function () {
      if (!$(this).parent().is(".active")) {
        $(this)
          .parent()
          .toggleClass("active")
          .children(".accordion-content")
          .slideToggle(500)
          .parent()
          .siblings(".active")
          .removeClass("active")
          .children(".accordion-content")
          .slideToggle(500);
      } else {
        $(this).parent().toggleClass("active");
        $(this).next().slideToggle(500);
      }
    });
  }
}

function jarallax() {
  $(".jarallax").jarallax({
    speed: 0.2,
    disableParallax: / iPad | iPhone | iPod | Android /,
    disableVideo: / iPad | iPhone | iPod | Android /,
  });
}

function myTabs() {
  $(".my-tabs").each(function () {
    var $this = $(this);
    $(".tabs-nav li:first").addClass("active");
    $this.find(".tab-container").find(".tab-content:first").show();
    $this.find(".tabs-nav li").click(function () {
      var corresponding = $(this).data("tab");
      $(".tab-content").hide();
      $(".tab-content." + corresponding).show();
      $(".tabs-nav li").removeClass("active");
      $(this).addClass("active");
    });
  });
  $(".products").each(function () {
    var $this = $(this);
    $(".filter-list .filter-item:first").addClass("active");
    $this.find(".products-list").find(".tab-content:first").show();
    $this.find(".filter-list .filter-item").click(function () {
      var corresponding = $(this).data("tab");
      $(".tab-content").hide();
      $(".tab-content." + corresponding).show();
      $(".filter-list .filter-item").removeClass("active");
      $(this).addClass("active");
    });
  });
}
function selectUi() {
  $(".dropdown").on("click", ".dropdown-select", function () {
    if ($(this).parents(".dropdown").hasClass("open")) {
      $(this).parents(".dropdown").removeClass("open");
      $(this).siblings(".dropdown-list").hide();
    } else {
      $(".dropdown").removeClass("open");
      $(this).parents(".dropdown").addClass("open");
      $(".dropdown-list").hide();
      $(this).siblings(".dropdown-list").show();
    }
  });
  var allOptions = $(".dropdown-list").children(".dropdown-item");
  $(".dropdown-list").on("click", ".dropdown-item", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $(this)
      .parents(".dropdown")
      .find(".dropdown-selected")
      .html($(this).html());

    $(this).parents(".dropdown-list").toggle();
    $(this).parents(".dropdown").toggleClass("open");
    $("input#inputInit").val($(this).data("val"));
  });
  var $menu = $(".dropdown");

  $(document).mouseup(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
      $menu.removeClass("open");
      $menu.find(".dropdown-list").hide();
    }
  });
}
// Scroll to Top
function scrollToTop() {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $("#scroll-top").addClass("show");
    } else {
      $("#scroll-top").removeClass("show");
    }
  });
  $("#scroll-top").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 1000, "easeInOutExpo");
    return false;
  });
}
function scrollSection() {
  var Nav = $(".menu"),
    NavTopPosition = Nav.offset().top,
    contentSections = $(".section-scroll");
  var header = $(".header");
  var heightHeader = $(".header").innerHeight();

  $(window).on("scroll", function () {
    if ($(window).width() > 1200) {
      if ($(window).scrollTop() > NavTopPosition) {
        //fix about navigation
        Nav.addClass("is-fixed");
      } else {
        Nav.removeClass("is-fixed");
      }
    }
    //on desktop - update the active link in the about fixed navigation
    updateNavigation();
  });
  function updateNavigation() {
    contentSections.each(function () {
      var actual = $(this),
        actualHeight =
          actual.height() +
          parseInt(actual.css("paddingTop").replace("px", "")) +
          parseInt(actual.css("paddingBottom").replace("px", "")),
        actualAnchor = Nav.find('a[href="#' + actual.attr("id") + '"]');
      if (
        actual.offset().top - heightHeader <= $(window).scrollTop() + 10 &&
        actual.offset().top + actualHeight - heightHeader >
          $(window).scrollTop()
      ) {
        actualAnchor.parent().addClass("active");
      } else {
        actualAnchor.parent().removeClass("active");
      }
    });
  }
  //smooth scrolling when clicking on the about navigation items
  Nav.find("ul a").on("click", function (event) {
    event.preventDefault();
    var target = $(this.hash);
    $("body,html").animate(
      {
        scrollTop: target.offset().top - heightHeader + 10,
      },
      600
    );
  });
}
$(document).ready(function () {
  App.Init();
  InitSlider();
  Headers();
  mappings();
  selectUi();
  scrollToTop();
  scrollSection();
  accordion();
  fixedNav();
  jarallax();
  myTabs();
  $(".custom-checkbox :checkbox").click(function () {
    $(".products-list .item").hide();
    $(".custom-checkbox :checkbox:checked").each(function () {
      $("." + $(this).val()).fadeIn();
    });

    if ($(".custom-checkbox :checkbox").filter(":checked").length < 1) {
      $(".products-list .item").fadeIn();
    }
  });
  $(".reset-btn").on("click", function () {
    $(this)
      .parents(".filter-dropdown")
      .find("input:checkbox")
      .prop("checked", false);
    $(".products-list .item").fadeIn();
  });
  $(".tab-content").each(function () {
    var items = $(this).find(".item");
    var numItems = items.length;
    var perPage = 8;

    items.slice(perPage).hide();

    $(this)
      .find(".pagination-container")
      .pagination({
        items: numItems,
        itemsOnPage: perPage,
        prevText: "<em class='lnr lnr-chevron-left'></em>",
        nextText: "<em class='lnr lnr-chevron-right'></em>",
        onPageClick: function (pageNumber) {
          var showFrom = perPage * (pageNumber - 1);
          var showTo = showFrom + perPage;
          items.hide().slice(showFrom, showTo).show();
        },
      });
  });
});
